export const DEFAULT_WIALON_SYNC_INTERVAL_SECONDS = 30;

export const WIALON_SYNC_INTERVAL_OPTIONS = [
  { value: 15, label: 'Every 15 seconds' },
  { value: 30, label: 'Every 30 seconds (default)' },
  { value: 60, label: 'Every 1 minute' },
  { value: 120, label: 'Every 2 minutes' },
  { value: 300, label: 'Every 5 minutes' },
];

/** Map / vehicle poll interval aligned with manager Wialon sync rate. */
export function getWialonMapPollMs(org) {
  if (org?.wialon_gps_enabled) {
    const seconds = Number(org.wialon_sync_interval_seconds) || DEFAULT_WIALON_SYNC_INTERVAL_SECONDS;
    return Math.max(5000, seconds * 1000);
  }
  return 10000;
}
